import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { UL } from '@blueprintjs/core';
import './KwicTable.css';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';

class Meta extends React.PureComponent {

  state = {
     
  }

  render() {
    const metadata=this.props.metadata;
    const sentMetadata=this.props.sentMetadata;

    const interfaceLanguage = Cookies.get(FRONT_USER_LANG_COOKIE_NAME) ? Cookies.get(FRONT_USER_LANG_COOKIE_NAME):"fr";
    //console.log(interfaceLanguage, this.props.collections, this.props.collection);
    const translateTag =  this.props.collection && 
                          this.props.collections.collection[this.props.collection] &&
                          this.props.collections.collection[this.props.collection].metaDataTag &&
                          this.props.collections.collection[this.props.collection].metaDataTag[interfaceLanguage]? 
      true:false;
    const metaDataEls = metadata ? Object.keys(metadata).sort().map( (key) => {
        const translatedTag=translateTag && this.props.collections.collection[this.props.collection].metaDataTag[interfaceLanguage][key]? 
          this.props.collections.collection[this.props.collection].metaDataTag[interfaceLanguage][key]:
          key;
        if (metadata[key]) {
          return (key==='externalLink') ? 
            <li key={key}><b>{translatedTag}</b>: <a target="blank" href={metadata[key]}>{metadata[key]}</a></li>:
            <li key={key} dangerouslySetInnerHTML={{ __html:'<b>'+translatedTag+"</b>: "+(metadata[key].match(/\\n/)?"<br/>- ":"")+metadata[key].replace(/\\n/g,"<br/>- ")}}></li>
        } else {
          return "";
        }
    }):[];
    const sentMetaDataEls = sentMetadata ? Object.keys(sentMetadata).sort().map((key) => {
        const translatedTag=translateTag && this.props.collections.collection[this.props.collection].metaDataTag[interfaceLanguage][key]? 
          this.props.collections.collection[this.props.collection].metaDataTag[interfaceLanguage][key]:
          key;
        return <li key={key}><b>{translatedTag}</b>: {sentMetadata[key]}</li>
    }):"";

    metaDataEls.unshift(
      <li key='sentId'><b>sentId</b>: {this.props.sentId}</li> 
    );

        return (
          <div className='dialogContainer'>
            <UL>
                {metaDataEls}
            </UL>

            { sentMetaDataEls.length > 0 && 
            <>
              <hr/>
              <UL>
                {sentMetaDataEls}
              </UL>
            </>
            }
          </div>  
        );

  }
}

Meta.propTypes = {
      metadata: PropTypes.object,
      sentMetadata: PropTypes.object,
      sentId: PropTypes.string,
      collections: PropTypes.object,
      collection: PropTypes.string

};

export default withTranslation()(Meta);
